import {Route} from '@angular/router';
import {VehicleDatabaseComponent} from './vehicle-database/vehicle-database.component';
import {ReportsComponent} from './reports/reports.component';
import {TrackVehicleComponent} from './track-vehicle/track-vehicle.component';
import {ProfileComponent} from './profile/profile.component';
import {AddVehicleComponent} from './add-vehicle/add-vehicle.component';
import {LoginComponent} from './auth/login/login.component';
import {LayoutComponent} from './layout/layout.component';
import {ForgotPasswordComponent} from './auth/forgotPassword/forgot-password/forgot-password.component';
import {ChangePasswordComponent} from './auth/change-password/change-password.component';
import {AuthGuardService} from './services/authGuard.service';
import {EditVehicleDatabaseComponent} from './edit-vehicle-database/edit-vehicle-database.component';
import {ContactUsComponent} from './contact-us/contact-us.component';
import {
    ForgotPasswordConfimComponent
} from './auth/forgotPassword/forgot-password-confim/forgot-password-confim.component';
import {
    ForgotPasswordRedirectComponent
} from './auth/forgotPassword/forgot-password-redirect/forgot-password-redirect.component';
import {BlackListedVehicleComponent} from './black-listed-vehicles/black-listed-vehicle/black-listed-vehicle.component';
import {SignupComponent} from './auth/signup/signup.component';
import {NavHeaderComponent} from './publicPage/nav-header/nav-header.component';
import {
    AddBlackListedVehicleComponent
} from './black-listed-vehicles/add-black-listed-vehicle/add-black-listed-vehicle.component';
import {OrganizationComponent} from './admin/organization/organization.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {AddOrganizationComponent} from './admin/add-organization/add-organization.component';
import {EditOrganizationComponent} from './admin/edit-organization/edit-organization.component';
import {OrganizationDetailShellComponent,} from './admin/organization-detail/organization-detail-shell.component';
import {OrganizationProfileComponent,} from './admin/organization-detail/organization-profile.component';
import {
    OrganizationOperationalReadinessPageComponent,
} from './admin/organization-detail/organization-operational-readiness-page.component';
import {
    OrganizationCustomerIntegrationsPageComponent,
} from './admin/organization-detail/organization-customer-integrations-page.component';
import {
    OrganizationEenAccountPageComponent,
} from './admin/organization-detail/organization-een-account-page.component';
import {OrganizationSuperUserTabGuard} from './services/organization-super-user-tab.guard';
import {EventsComponent} from './events/events.component';
import {ServiceHealthStatusComponent} from './service-health-status/service-health-status.component';
import {HotListedVehicleComponent} from './hotListedVehicle/hot-listed-vehicle/hot-listed-vehicle.component';
import {AddHotListedVehicleComponent} from './hotListedVehicle/add-hot-listed-vehicle/add-hot-listed-vehicle.component';
import {AddCamerasComponent} from './cameraPage/add-cameras/add-cameras.component';
import {ViewCamerasComponent} from './cameraPage/view-cameras/view-cameras.component';
import {EditCameraComponent} from './cameraPage/edit-camera/edit-camera.component';
import {ViewBridgesComponent} from './bridgePage/view-bridges/view-bridges.component';
import {AddBridgeComponent} from './bridgePage/add-bridge/add-bridge.component';
import {EditBridgeComponent} from './bridgePage/edit-bridge/edit-bridge.component';
import {DeviceHealthComponent} from './device-health/device-health.component';
import {VerifyMobileNumberComponent} from './verify-mobile-number/verify-mobile-number.component';
import {AnalyticsComponent} from './analytics/analytics.component';
import {AlertComponent} from './alert/alert.component';
import {SettingsComponent} from './pages/settings/settings.component';
import {LogsComponent} from './logs/logs.component';
import {LoginActivityComponent} from './login-activity/login-activity.component';
import {SubscriptionsComponent} from './subscriptions/subscription/subscriptions.component';
import {SubscriptionFormComponent} from './subscriptions/subscription-form/subscription-form.component';
import {SubscriptionDetailComponent} from './subscriptions/subscription-detail/subscription-detail.component';
import {SuperUserGuardService} from './services/superUserGuard.service';
import {LeadManagementGuardService} from './services/leadManagementGuard.service';
import {SubscriptionAccessGuardService} from './services/subscriptionAccessGuard.service';
import {MemberMutationGuardService} from './services/memberMutationGuard.service';
import {VisitorManagementAdminGuardService} from './services/visitorManagementAdminGuard.service';
import {CoreOpsAccessGuardService} from './services/coreOpsAccessGuard.service';
import {HelpSupportAccessGuardService} from './services/helpSupportAccessGuard.service';
import {CameraManagementAccessGuardService} from './services/cameraManagementAccessGuard.service';
import {OrganizationMutationGuardService} from './services/organizationMutationGuard.service';
import {VisitorSubmitAccessGuardService} from './services/visitorSubmitAccessGuard.service';
import {SettingsAccessGuardService} from './services/settingsAccessGuard.service';
import {PartnersComponent} from './admin/partners/partners.component';
import {PartnerFormComponent} from './admin/partners/partner-form.component';
import {ApiKeysComponent} from './admin/api-keys/api-keys.component';
import {ContactUsRequestsComponent} from './admin/contact-us-requests/contact-us-requests.component';
import {RegisterListComponent} from './visitor-management/register-engine/register-list/register-list.component';
import {RegisterFormComponent} from './visitor-management/register-engine/register-form/register-form.component';
import {FieldConfigComponent} from './visitor-management/register-engine/field-config/field-config.component';
import {ClusterComponent} from './visitor-management/register-engine/cluster/cluster.component';
import {ClusterFormComponent} from './visitor-management/register-engine/cluster-form/cluster-form.component';
import {EntryListComponent} from './visitor-management/register-engine/entry-list/entry-list.component';
import {SelectRegisterComponent} from './visitor-management/register-engine/select-register/select-register.component';
import {EntryFormComponent} from './visitor-management/register-engine/entry-form/entry-form.component';
import {RoleLandingComponent} from './role-landing.component';
import {LeadDashboardComponent} from './lead-management/lead-dashboard/lead-dashboard.component';
import {LeadListComponent} from './lead-management/lead-list/lead-list.component';
import {LeadFormComponent} from './lead-management/lead-form/lead-form.component';
import {LeadDetailComponent} from './lead-management/lead-detail/lead-detail.component';
import {FollowUpListComponent} from './lead-management/follow-up-list/follow-up-list.component';
import {DemoScheduleComponent} from './lead-management/demo-schedule/demo-schedule.component';
import {
    SalesInstallationPartnersComponent
} from './admin/sales-installation-partners/sales-installation-partners.component';
import {
    SalesInstallationPartnerFormComponent
} from './admin/sales-installation-partners/sales-installation-partner-form.component';
import {
    SalesInstallationPartnerDetailComponent
} from './admin/sales-installation-partners/sales-installation-partner-detail.component';
import {InitialOccupancyUploadComponent} from './admin/initial-occupancy-upload/initial-occupancy-upload.component';
import {VehicleMonitoringComponent} from './vehicle-monitoring/vehicle-monitoring.component';
import {
    EditVehicleMonitoringComponent
} from './vehicle-monitoring/edit-vehicle-monitoring/edit-vehicle-monitoring.component';
import {OperationsShellComponent} from './operations/operations-shell/operations-shell.component';
import {OperationsHomeComponent} from './operations/operations-home/operations-home.component';
import {
    VehicleTransactionListComponent
} from './operations/vehicle-transaction-list/vehicle-transaction-list.component';
import {
    VehicleTransactionDetailComponent
} from './operations/vehicle-transaction-detail/vehicle-transaction-detail.component';
import {ProviderEventListComponent} from './operations/provider-event-list/provider-event-list.component';
import {ProviderEventDetailComponent} from './operations/provider-event-detail/provider-event-detail.component';
import {OperationsAccessGuardService} from './services/operationsAccessGuard.service';
import {VisionConfigurationAccessGuardService} from './services/visionConfigurationAccessGuard.service';
import {DeviceHealthAccessGuardService} from './services/deviceHealthAccessGuard.service';
import {VisionConfigShellComponent} from './vision-configuration/vision-config-shell/vision-config-shell.component';
import {
    OrganizationVisionSettingsComponent
} from './vision-configuration/organization-vision-settings/organization-vision-settings.component';
import {
    CameraAnalyticsConfigComponent
} from './vision-configuration/camera-analytics-config/camera-analytics-config.component';
import {
    AnalyticsDefinitionsListComponent
} from './vision-configuration/analytics-definitions-list/analytics-definitions-list.component';
import {ProviderListComponent} from './vision-provider-management/provider-list/provider-list.component';
import {
    ProviderDetailsShellComponent
} from './vision-provider-management/provider-details-shell/provider-details-shell.component';
import {ProviderOverviewComponent} from './vision-provider-management/provider-overview/provider-overview.component';
import {
    ProviderAuthenticationComponent
} from './vision-provider-management/provider-authentication/provider-authentication.component';
import {
    ProviderEventSubscriptionsComponent
} from './vision-provider-management/provider-event-subscriptions/provider-event-subscriptions.component';
import {
    ProviderDiagnosticsTabComponent
} from './vision-provider-management/provider-diagnostics-tab/provider-diagnostics-tab.component';

export const routes: Route[] = [
   
    { path: 'login', component: LoginComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent},
    { path: 'reset-password', component: ForgotPasswordRedirectComponent },
    { path: 'forgot-password-confirm', component: ForgotPasswordConfimComponent},
    { path: 'verify-mobile-otp', component: VerifyMobileNumberComponent, canActivate: [AuthGuardService] },
    // Staff-only Health Status — Kyra Super User (matches backend IsSuperUser on platform-health)
    {path: 'health', component: ServiceHealthStatusComponent, canActivate: [AuthGuardService, SuperUserGuardService]},
    {path: 'service-health-status', redirectTo: 'health', pathMatch: 'full'},

   
    // { path: '', redirectTo: 'login', pathMatch: "full"},
    
    { path: '', 
        component: LayoutComponent,
        canActivate: [AuthGuardService],
        // Re-check JWT on every child navigation (P22-08) — parent canActivate alone
        // does not re-run when moving between layout children after soft expiry.
        canActivateChild: [AuthGuardService],
        children:[
        
           
            { path: 'vehicle', component: VehicleDatabaseComponent, canActivate: [CoreOpsAccessGuardService] },
            { path: 'reports', component: ReportsComponent, canActivate: [CoreOpsAccessGuardService] },
            { path: 'track', component: TrackVehicleComponent, canActivate: [CoreOpsAccessGuardService] },
            { path: 'profile', component: ProfileComponent },
            {
                path: 'add-vehicle',
                component: AddVehicleComponent,
                canActivate: [CoreOpsAccessGuardService, MemberMutationGuardService],
            },
            { path: "profile/edit/:pk", component: ProfileComponent },
            {path: "vehicle/bulk", redirectTo: 'vehicle', pathMatch: 'full'},
            { path: 'change-password', component: ChangePasswordComponent},
            {
                path: 'get-vehicle/:pk',
                component: EditVehicleDatabaseComponent,
                canActivate: [CoreOpsAccessGuardService, MemberMutationGuardService]
            },
            {
                path: 'edit-vehicle/:pk',
                component: EditVehicleDatabaseComponent,
                canActivate: [CoreOpsAccessGuardService, MemberMutationGuardService]
            },
            {
                path: 'contact-us',
                component: ContactUsComponent,
                // P22-05: Help & Support — customer-org Admin/Member/Demo User.
                canActivate: [HelpSupportAccessGuardService],
            },
            {
                path: 'blacked-vehicle',
                component: BlackListedVehicleComponent,
                canActivate: [CoreOpsAccessGuardService],
            },
            {
                path: 'add-vehicle-black-list',
                component: AddBlackListedVehicleComponent,
                canActivate: [CoreOpsAccessGuardService, MemberMutationGuardService]
            },
            // { path: 'staff', component: StaffComponent},
            { path: 'organization', component: OrganizationComponent},
            {
                path: 'signup',
                component: SignupComponent,
                canActivate: [OrganizationMutationGuardService],
            },
            { path: 'dashboard', component: DashboardComponent},
            {
                path: 'organization/add',
                component: AddOrganizationComponent,
                canActivate: [OrganizationMutationGuardService],
            },
            {
                path: 'organization/edit/:pk',
                component: EditOrganizationComponent,
                canActivate: [OrganizationMutationGuardService],
            },
            {
                path: 'organization/edit',
                component: EditOrganizationComponent,
                canActivate: [OrganizationMutationGuardService],
            },
            {
                path: 'organization/:organizationId',
                component: OrganizationDetailShellComponent,
                // Members denied; Sales Managers may open profile from the customer listing.
                canActivate: [MemberMutationGuardService],
                children: [
                    {path: '', pathMatch: 'full', redirectTo: 'profile'},
                    {path: 'profile', component: OrganizationProfileComponent},
                    {
                        path: 'operational-readiness',
                        component: OrganizationOperationalReadinessPageComponent,
                        canActivate: [OrganizationSuperUserTabGuard],
                    },
                    {
                        path: 'customer-integrations',
                        component: OrganizationCustomerIntegrationsPageComponent,
                        canActivate: [OrganizationSuperUserTabGuard],
                    },
                    {
                        path: 'een-account',
                        component: OrganizationEenAccountPageComponent,
                        canActivate: [OrganizationSuperUserTabGuard],
                    },
                ],
            },
            { path: 'events', component: EventsComponent, canActivate: [CoreOpsAccessGuardService]},
            {
                path: 'view-hotlist',
                component: HotListedVehicleComponent,
                canActivate: [CoreOpsAccessGuardService],
            },
            {
                path: 'add-hotlist',
                component: AddHotListedVehicleComponent,
                canActivate: [CoreOpsAccessGuardService, MemberMutationGuardService],
            },
            {
                path: 'vehicle-monitoring',
                component: VehicleMonitoringComponent,
                canActivate: [CoreOpsAccessGuardService],
            },
            { path: 'vehicle-alert-rules', redirectTo: 'vehicle-monitoring', pathMatch: 'full'},
            {
                path: 'add-vehicle-monitoring',
                component: EditVehicleMonitoringComponent,
                canActivate: [CoreOpsAccessGuardService, MemberMutationGuardService]
            },
            {
                path: 'add-vehicle-alert',
                redirectTo: 'add-vehicle-monitoring',
                pathMatch: 'full',
            },
            {
                path: 'edit-vehicle-monitoring/:id',
                component: EditVehicleMonitoringComponent,
                canActivate: [CoreOpsAccessGuardService, MemberMutationGuardService]
            },
            {
                path: 'edit-vehicle-alert/:pk',
                component: EditVehicleMonitoringComponent,
                canActivate: [CoreOpsAccessGuardService, MemberMutationGuardService]
            },
            {
                path: 'add-camera',
                component: AddCamerasComponent,
                canActivate: [SuperUserGuardService],
            },
            {
                path: 'view-cameras',
                component: ViewCamerasComponent,
                // SU + Admin/Member; Sales Manager denied (restores pre–N-01 SU Camera workflow).
                canActivate: [CameraManagementAccessGuardService],
            },
            {
                path: 'edit-camera/:pk',
                component: EditCameraComponent,
                // P22-05: camera mutations are Super User only (Admin/Member view-only).
                canActivate: [AuthGuardService, SuperUserGuardService],
            },
            {
                path: 'device-health',
                component: DeviceHealthComponent,
                // Auth first (also on layout); then RoleService.canAccessDeviceHealth (TD-074).
                canActivate: [AuthGuardService, DeviceHealthAccessGuardService],
            },
            {
                path: 'view-bridges',
                component: ViewBridgesComponent,
                // P22-05: Admin/Member may view bridges; mutations stay Super User–only.
                canActivate: [CameraManagementAccessGuardService],
            },
            {path: 'add-bridge', component: AddBridgeComponent, canActivate: [AuthGuardService, SuperUserGuardService]},
            {
                path: 'edit-bridge/:pk',
                component: EditBridgeComponent,
                canActivate: [AuthGuardService, SuperUserGuardService]
            },
            { path: 'analytics', component: AnalyticsComponent, canActivate: [CoreOpsAccessGuardService] },
            { path: 'alert', component: AlertComponent, canActivate: [CoreOpsAccessGuardService] },
            {
                path: 'settings',
                component: SettingsComponent,
                canActivate: [AuthGuardService, SettingsAccessGuardService],
            },
            { path: 'logs', component: LogsComponent, canActivate: [AuthGuardService, SuperUserGuardService] },
            { path: 'login-activity', component: LoginActivityComponent, canActivate: [AuthGuardService, SuperUserGuardService] },
            { path: 'subscriptions', component: SubscriptionsComponent, canActivate: [AuthGuardService, SubscriptionAccessGuardService] },
            {
                path: 'subscriptions/new',
                component: SubscriptionFormComponent,
                canActivate: [AuthGuardService, SuperUserGuardService],
            },
            {
                path: 'subscriptions/:id/edit',
                component: SubscriptionFormComponent,
                canActivate: [AuthGuardService, SuperUserGuardService],
            },
            { path: 'subscriptions/:id', component: SubscriptionDetailComponent, canActivate: [AuthGuardService, SubscriptionAccessGuardService] },
            { path: 'admin/partners', component: PartnersComponent, canActivate: [AuthGuardService, SuperUserGuardService] },
            { path: 'admin/partners/new', component: PartnerFormComponent, canActivate: [AuthGuardService, SuperUserGuardService] },
            { path: 'admin/partners/:id/edit', component: PartnerFormComponent, canActivate: [AuthGuardService, SuperUserGuardService] },
            { path: 'admin/api-keys', component: ApiKeysComponent, canActivate: [AuthGuardService, SuperUserGuardService] },
            {
                path: 'admin/contact-us-requests',
                component: ContactUsRequestsComponent,
                canActivate: [AuthGuardService, SuperUserGuardService]
            },
            {
                path: 'admin/initial-occupancy-upload',
                component: InitialOccupancyUploadComponent,
                canActivate: [AuthGuardService, SuperUserGuardService]
            },
            { path: 'admin/sales-installation-partners', component: SalesInstallationPartnersComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'admin/sales-installation-partners/new', component: SalesInstallationPartnerFormComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'admin/sales-installation-partners/:id/edit', component: SalesInstallationPartnerFormComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'admin/sales-installation-partners/:id', component: SalesInstallationPartnerDetailComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'lead-management/dashboard', component: LeadDashboardComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'lead-management/leads', component: LeadListComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'lead-management/leads/new', component: LeadFormComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'lead-management/leads/:id/edit', component: LeadFormComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'lead-management/leads/:id', component: LeadDetailComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'lead-management/follow-ups', component: FollowUpListComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'lead-management/demo-schedule', component: DemoScheduleComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            {
                path: 'visitor-management/registers',
                component: RegisterListComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/registers/create',
                component: RegisterFormComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/registers/:id/edit',
                component: RegisterFormComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/registers/:id/fields',
                component: FieldConfigComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/clusters',
                component: ClusterComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/clusters/create',
                component: ClusterFormComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/clusters/:id/edit',
                component: ClusterFormComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/entries',
                component: EntryListComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/select-register',
                component: SelectRegisterComponent,
                canActivate: [VisitorSubmitAccessGuardService],
            },
            {
                path: 'visitor-management/entry/:id/edit',
                component: EntryFormComponent,
                canActivate: [VisitorSubmitAccessGuardService],
            },
            {
                path: 'visitor-management/entry/:registerId',
                component: EntryFormComponent,
                canActivate: [VisitorSubmitAccessGuardService],
            },
            {
                path: 'operations',
                component: OperationsShellComponent,
                canActivate: [OperationsAccessGuardService],
                children: [
                    {path: '', component: OperationsHomeComponent},
                    {path: 'transactions', component: VehicleTransactionListComponent},
                    {path: 'transactions/:id', component: VehicleTransactionDetailComponent},
                    {path: 'provider-events', component: ProviderEventListComponent},
                    {path: 'provider-events/:id', component: ProviderEventDetailComponent},
                    {
                        path: 'provider-management',
                        redirectTo: '/vision-configuration/provider-management',
                        pathMatch: 'full',
                    },
                    {
                        path: 'provider-management/providers/:providerId',
                        redirectTo: '/vision-configuration/provider-management/providers/:providerId',
                    },
                    {
                        path: 'provider-management/providers/:providerId/:tab',
                        redirectTo: '/vision-configuration/provider-management/providers/:providerId/:tab',
                    },
                ],
            },
            {
                path: 'vision-provider-management',
                redirectTo: 'vision-configuration/provider-management',
                pathMatch: 'full',
            },
            {
                path: 'vision-provider-management/providers/:providerId',
                redirectTo: 'vision-configuration/provider-management/providers/:providerId',
            },
            {
                path: 'vision-provider-management/providers/:providerId/:tab',
                redirectTo: 'vision-configuration/provider-management/providers/:providerId/:tab',
            },
            {
                path: 'vision-configuration',
                component: VisionConfigShellComponent,
                canActivate: [VisionConfigurationAccessGuardService],
                children: [
                    {path: '', redirectTo: 'organization', pathMatch: 'full'},
                    {path: 'organization', component: OrganizationVisionSettingsComponent},
                    {path: 'cameras', component: CameraAnalyticsConfigComponent},
                    {path: 'analytics-definitions', component: AnalyticsDefinitionsListComponent},
                    {
                        path: 'provider-management',
                        canActivate: [SuperUserGuardService],
                        children: [
                            {path: '', component: ProviderListComponent},
                            {
                                path: 'providers/:providerId',
                                component: ProviderDetailsShellComponent,
                                children: [
                                    {path: '', redirectTo: 'overview', pathMatch: 'full'},
                                    {path: 'overview', component: ProviderOverviewComponent},
                                    {path: 'authentication', component: ProviderAuthenticationComponent},
                                    {path: 'event-subscriptions', component: ProviderEventSubscriptionsComponent},
                                    {path: 'diagnostics', component: ProviderDiagnosticsTabComponent},
                                ],
                            },
                        ],
                    },
                ],
            },

            { path: '', component: RoleLandingComponent, pathMatch: "full"}


        ]
    },
    { path: '',
        component:NavHeaderComponent,
        children:[
            
            
        ]
    },
    { path: "**", redirectTo: ""}
    
    
        
    
];
